<template>
  <div>
    <br />
    <el-row :gutter="20">
      <el-col :sm="15">
        <el-card v-loading="loading" element-loading-text="Cargando...">
          <div slot="header" class="clearfix">
            <span class="title-list">Generar reporte de riesgos personalizados</span>
          </div>
          <el-row :gutter="26" v-loading="generar" :element-loading-text="texto_carga"
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-col :sm="24">
              <el-form label-position="top">
                <el-form-item label="SELECCIONE UNA FAENA">
                  <el-select @change="setValues" v-model="faena_selected" size="medium" style="width: 100%"
                    placeholder="Seleccione Faena">
                    <el-option v-for="item in listadoFaenas" :key="item.faena_id" :label="item.nombre"
                      :value="item.faena_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :sm="24">
              <el-form label-position="top">
                <el-form-item label="SELECCIONE UN TIPO DE INVENTARIO">
                  <el-select v-model="tipo_contrato" size="medium" style="width: 100%"
                    placeholder="Seleccione un tipo de contrato">
                    <el-option v-for="(item, index) in tipos" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :sm="24">
              <el-form label-position="top">
                <el-form-item label="SELECCIONE UN ÁREA">
                  <el-alert v-if="area_selected_name" type="info" show-icon style="
                  font-size: 13px;
                  padding: 0px;
                  padding-left: 10px;
                  font-weight: bold;
                  margin-bottom: 15px;
                ">
                    USTED HA SELECCIONADO
                    <span style="color: red">{{ area_selected_name }}</span>
                  </el-alert>
                  <small>BÚSQUEDA POR NOMBRE DEL ÁREA</small>
                  <el-input style="margin-bottom: 15px" size="medium" placeholder="Filtro por nombre del área"
                    v-model="filterText">
                  </el-input>
                  <el-tree :data="tree" :props="defaultProps" :filter-node-method="filterNode" ref="tree2"
                    @node-click="handleNodeClick"></el-tree>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :sm="24">
              <el-form label-position="top">
                <el-form-item label="SELECCIONE MFL (PUEDE SELECCIONAR MÁS DE UNA OPCIÓN)">
                  <el-select multiple v-model="mfl_selected" size="medium" style="width: 100%"
                    placeholder="Seleccione los mfl que desea utilizar">
                    <el-option v-for="(item, index) in mfl" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :sm="24">
              <el-form label-position="top">
                <el-form-item label="SELECCIONE EL ESTADO DEL INVENTARIO (PUEDE SELECCIONAR MÁS DE UNA OPCIÓN)">
                  <el-select multiple v-model="status_selected" size="medium" style="width: 100%"
                    placeholder="Seleccione los estados que desea utilizar">
                    <el-option v-for="(item, index) in status" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :sm="24">
              <el-form label-position="top">
                <el-form-item label="SELECCIONE UN TIPO DE RIESGO">
                  <el-select v-model="tipo_selected" size="medium" style="width: 100%"
                    placeholder="Seleccione el tipo de riesgo">
                    <el-option v-for="(item, index) in tipos_riesgos" :key="index" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :sm="24">
              <el-form label-position="top">
                <el-form-item label="SELECCIONE CATEGORÍA DEL RIESGO (PUEDE SELECCIONAR MÁS DE UNA OPCIÓN)">
                  <el-select multiple v-model="categoria_selected" size="medium" style="width: 100%"
                    placeholder="Seleccione las categorias que desea utilizar">
                    <el-option v-for="(item, index) in categorias" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :sm="24" v-if="$store.getters.user && $store.getters.user.admin">
              <div>
                <span style="font-size: 13px;">INCLUIR DUEÑO DE CONTRATO</span>
                <el-switch style="margin-left: 20px;" v-model="owner" active-text="SI" inactive-text="NO">
                </el-switch>
              </div>
              <br>
            </el-col>
            <el-col :sm="24">
              <div>
                <span style="font-size: 13px;">INCLUIR RRR</span>
                <el-switch style="margin-left: 20px;" v-model="rrr" active-text="SI" inactive-text="NO">
                </el-switch>
              </div>
              <br>
              <div>
                <span style="font-size: 13px;">INCLUIR CLASIFICACIÓN (MATERIALES / NO MATERIALES)</span>
                <el-switch style="margin-left: 20px;" v-model="diff" active-text="SI" inactive-text="NO">
                </el-switch>
              </div>
              <br>
              <div>
                <span style="font-size: 13px;">INCLUIR ÁRBOL DE ÁREAS</span>
                <el-switch style="margin-left: 20px;" v-model="arbol" active-text="SI" inactive-text="NO">
                </el-switch>
              </div>
            </el-col>
            <el-col :sm="24">
              <br />
              <el-button :loading="generar" style="width: 100%" type="primary" icon="el-icon-download"
                @click="getReport">
                GENERAR Y DESCARGAR REPORTE</el-button>

            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :sm="9">
        <el-card v-loading="loading" element-loading-text="Cargando...">
          <div slot="header" class="clearfix">
            <span class="title-list">Video de capsula Reporte Riesgos Personalizado</span>
          </div>
          <iframe
            width="100%" height="315" src="https://www.youtube.com/embed/qYgroMiUDAo?si=CQfgkG3k029fwW0H"
            title="Validador de la revisión anual" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      texto_carga: "",
      arbol: false,
      rrr: false,
      diff: false,
      owner: false,
      generar: false,
      filterText: "",
      area_selected: "",
      area_selected_name: "",
      loading: false,
      tree: [],
      defaultProps: {
        children: "children",
        label: "nombre",
      },
      status_selected: [],
      status: [
        {
          label: "BORRADOR",
          value: "0",
        },
        {
          label: "EN REVISIÓN",
          value: "1",
        },
        {
          label: "APROBADO",
          value: "2",
        },
        {
          label: "IMPORTADO BORRADOR",
          value: "3",
        },
      ],
      faena_selected: "5a6f78337b772dcfe68241d5",
      listadoFaenas: [
        {
          nombre: "MEL",
          faena_id: "5a6f78337b772dcfe68241d5",
        },
        {
          nombre: "SPENCE",
          faena_id: "5a6f78417b772dcfe68241e5",
        },
        {
          nombre: "CERRO COLORADO",
          faena_id: "5a6f784e7b772dcfe68241f4",
        },
        {
          nombre: "BHP",
          faena_id: "5b48f15d6f0ed90fc02826e3",
        },
      ],
      tipo_contrato: "Propio",
      tipos: [
        {
          label: "TODOS",
          value: "all",
        },
        {
          label: "PROPIO",
          value: "Propio",
        },
        {
          label: "CONTRATISTA",
          value: "Contratista",
        },
      ],
      categoria_selected: [],
      categorias: [
        {
          label: "SALUD",
          value: "salud",
        },
        {
          label: "SEGURIDAD",
          value: "seguridad",
        },
        {
          label: "MEDIOAMBIENTE",
          value: "medioambiente",
        },
      ],
      tipo_selected: "",
      tipos_riesgos: [
        {
          label: "TODOS",
          value: "all",
        },
        {
          label: "PERSONALIZADOS",
          value: true,
        },
        {
          label: "ESTANDARIZADOS",
          value: false,
        },
      ],
      mfl_selected: [],
      mfl: [
        {
          label: "1",
          value: "1",
        },
        {
          label: "2",
          value: "2",
        },
        {
          label: "3",
          value: "3",
        },
        {
          label: "4",
          value: "4",
        },
        {
          label: "5",
          value: "5",
        },
      ],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree2.filter(val);
    },
  },
  created() {
    this.getTree(this.faena_selected);
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.nombre.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    handleNodeClick(data) {
      this.area_selected = data._id;
      this.area_selected_name = data.nombre;
    },
    setValues(tipo) {
      this.getTree(this.faena_selected);
      this.area_selected = "";
      this.area_selected_name = "";
    },
    async getTree(id) {
      this.loading = true;
      var response = await axios.get(`/data-science/getArbolEstructura/${id}`);
      this.tree = response.data;
      this.loading = false;
    },
    async getReport() {
      if (this.faena_selected === "") {
        this.$notify({
          title: "Información",
          message: "Debes seleccionar una faena",
          type: "warning",
        });
        return false;
      }

      if (this.tipo_contrato === "") {
        this.$notify({
          title: "Información",
          message: "Debes seleccionar un tipo de contrato",
          type: "warning",
        });
        return false;
      }

      if (this.area_selected === "") {
        this.$notify({
          title: "Información",
          message: "Debes seleccionar un área",
          type: "warning",
        });
        return false;
      }

      if (this.mfl_selected.length === 0) {
        this.$notify({
          title: "Información",
          message: "Debes seleccionar al menos un MFL",
          type: "warning",
        });
        return false;
      }

      if (this.status_selected.length === 0) {
        this.$notify({
          title: "Información",
          message: "Debes seleccionar al menos un estado del inventario",
          type: "warning",
        });
        return false;
      }

      if (this.tipo_selected === "") {
        this.$notify({
          title: "Información",
          message: "Debes seleccionar al menos un tipo de riesgo",
          type: "warning",
        });
        return false;
      }

      if (this.categoria_selected.length === 0) {
        this.$notify({
          title: "Información",
          message: "Debes seleccionar al menos una categoría del riesgo",
          type: "warning",
        });
        return false;
      }

      this.generar = true;

      var response = await axios.get(`/data-science/contratos/cantidadFiltro`, {
        params: {
          query: JSON.parse(
            JSON.stringify({
              arbol: this.arbol,
              diff: this.diff,
              rrr: this.rrr,
              owner: this.owner,
              type: this.tipo_contrato,
              faena_id: this.faena_selected,
              areas: this.area_selected,
              mfl: this.mfl_selected,
              status: this.status_selected,
              custom: this.tipo_selected,
              tipo_riesgo: this.categoria_selected
            })
          ),
        }
      });

      var cantidad_partes = Math.ceil(response.data[0]["cantidad_datos"] / 4);
      var finish = 5;

      if (Math.ceil(response.data[0]["cantidad_datos"]) < 4) {
        finish = 2;
      }

      const FileDownload = require("js-file-download");

      var count = 1

      do {
        this.texto_carga = "Generando Reporte de Riesgos Personalizados - Parte " + count;
        var response = await axios.get(`/data-science/reportes/reporte-riesgo`, {
          params: {
            query: JSON.parse(
              JSON.stringify({
                arbol: this.arbol,
                diff: this.diff,
                rrr: this.rrr,
                owner: this.owner,
                type: this.tipo_contrato,
                faena_id: this.faena_selected,
                areas: this.area_selected,
                mfl: this.mfl_selected,
                status: this.status_selected,
                custom: this.tipo_selected,
                tipo_riesgo: this.categoria_selected,
                page: count,
                skip: cantidad_partes
              })
            ),
          },
          responseType: "blob",
        });
        FileDownload(response.data, "Reporte Riesgos Personalizado Parte " + count + ".xlsx");
        count++;
      } while (count < finish);
      this.generar = false;
    },
  },
};
</script>

<style scoped>
.title-list {
  font-size: 15px;
  font-weight: bold;
  color: rgb(246, 123, 47);
}
</style>